import { Util } from "/global/js/util.min.js?v=1743070040";
const util = new Util();
export default class SendEmail {
  constructor(form) {
    this.ajaxHandler = '/global/ajaxHandlerGlobal.php';
    this.form = form;
  }
  validate() {
    if (this.form && !util.validateFormRequiredFields(this.form)) {
      this.form.classList.add('was-validated');
      return false;
    }
    return true;
  }
  resetValidate() {
    this.form.classList.remove('was-validated');
  }
  send(recaptchaToken, mailData = {}) {
    return new Promise((resolve, reject) => {
      if (!this.validate()) {
        reject("Form did not validate");
        return;
      }
      const data = {};
      Object.assign(data, {
        sendToEmail: '',
        showInCms: 0,
        emailCategory: '',
        departmentId: '',
        subject: '',
        successMsg: '',
        formDataExtra: {}
      }, mailData);
      const formData = new FormData();
      formData.append('sendToEmail', data.sendToEmail);
      formData.append('showInCms', data.showInCms);
      formData.append('emailCategory', data.emailCategory);
      formData.append('departmentId', data.departmentId);
      formData.append('subject', data.subject);
      formData.append('successMsg', data.successMsg);
      formData.append('g-recaptcha-response', recaptchaToken);
      if (this.form) {
        [...this.form.elements].forEach(input => {
          formData.append(input.name, input.value);
        });
      }
      if (data.formDataExtra) {
        for (const [key, value] of Object.entries(data.formDataExtra)) {
          formData.append(`${key}`, `${value}`);
        }
      }
      fetch(this.ajaxHandler + '?handler=sendEmail', {
        method: 'POST',
        body: formData
      }).then(response => response.json().then(response => {
        if (response.error) {
          pubsub.trigger('error', response);
          reject(false);
          return;
        }
        if (this.form) {
          [...this.form.elements].forEach(input => {
            if (input.name.startsWith('data')) {
              input.value = '';
            }
          });
          this.resetValidate();
        }
        pubsub.trigger('success', response);
        resolve(true);
      }));
    });
  }
  sendClean(mailData = {}) {
    return new Promise((resolve, reject) => {
      const data = {};
      Object.assign(data, {
        sendToEmail: '',
        subject: '',
        content: '',
        replyTo: '',
        successMsg: false
      }, mailData);
      const formData = new FormData();
      formData.append(`sendToEmail`, `${data.sendToEmail}`);
      formData.append(`subject`, `${data.subject}`);
      formData.append(`content`, `${data.content}`);
      formData.append(`replyTo`, `${data.replyTo}`);
      formData.append(`ommitRecaptchaCheck`, `true`);
      formData.append(`ommitDecryptSendToEmail`, `true`);
      fetch(this.ajaxHandler + '?handler=sendEmail', {
        method: 'POST',
        body: formData
      }).then(response => response.json().then(response => {
        if (response.error) {
          pubsub.trigger('error', response);
          reject(false);
          return;
        }
        if (data.successMsg) {
          pubsub.trigger('success', response);
        }
        resolve(true);
      }));
    });
  }
}